import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NavbarComponent } from './components/navbar/navbar.component';
import { RouterOutlet } from '@angular/router';
import {WaPageComponent, WaToastContainerComponent} from "angular-awesome";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NavbarComponent, RouterOutlet, WaPageComponent, WaToastContainerComponent]
})
export class AppComponent {
  title = 'staff-allocation-webapp';
}
